/* Created by Interactive 63 - https://interactive63.com */
/**
 * The minified runtime as a string, bundled at build time, for inlining into exports and for
 * the "Download runtime" button.
 */
import runtime from 'virtual:svg-tweener-runtime';

export const RUNTIME_CODE: string = runtime.code;
export const RUNTIME_BYTES: number = runtime.bytes;
